import React from 'react';
import { Card, Divider } from 'antd';

function AnswerCard({ children, title }) {
	return <Card bordered={false}>
		<div>
			{title && <h4>{title}</h4>}
			<Divider/>
			{children}
		</div>
	</Card>;
}

export default AnswerCard;


// WEBPACK FOOTER //
// ./src/components/AnswerCard/AnswerCard.js